/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core';
import {
    string, object, bool, any, number,
} from 'prop-types';
import ChevronRight from '@material-ui/icons/ChevronRight';

const styles = (theme) => ({
    root: {
        display: 'flex',
        padding: '10px 0',
        color: theme.palette.colorNeutral80,
        borderBottom: `1px solid ${theme.palette.colorNeutral50}`,
        cursor: 'pointer',
        width: '100%',
        alignItems: 'center',
    },
    titleWrapper: {
        minWidth: '270px',
    },
    rightChevron: {
        marginLeft: 'auto',
    },
});

const GraphqlPDPGiftMessageListItemUI = ({
    classes,
    title,
    showCount,
    count,
    value,
}) => (
    <div className={classes.root}>
        <div value={value} className={classes.titleWrapper}>
            {title}
            {showCount && <span> ({count})</span>}
        </div>
        <div className={classes.rightChevron} value={value}><ChevronRight /></div>
    </div>
);

GraphqlPDPGiftMessageListItemUI.propTypes = {
    classes: object.isRequired,
    title: string.isRequired,
    showCount: bool,
    count: number,
    value: any,
};

GraphqlPDPGiftMessageListItemUI.defaultProps = {
    showCount: false,
    count: 0,
    value: '',
};
export default withStyles(styles)(GraphqlPDPGiftMessageListItemUI);
